import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1","key":"svg-0"}],["path",{"d":"M16 10l4 4","key":"svg-1"}],["path",{"d":"M16 14l4 -4","key":"svg-2"}]]

const IconColumnRemove = createReactComponent('outline', 'column-remove', 'ColumnRemove', __iconNode);

export default IconColumnRemove;